"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require("./neptune");

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require("./_n");

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.sort = {
  init: function init(p) {
    p = p || document;

    _neptune2.default.debug.info("sort:init", { el: p });

    _n3.default.qsa("[neptune-sort]", p).forEach(function (el) {
      var _sort = {};

      try {
        if (!!el.getAttribute("neptune-sort")) {
          _sort = USON.parse(el.getAttribute("neptune-sort").replace(/'/g, '"').replace(/`/g, "'").replace(/</g, "[").replace(/>/g, "]"), "array")[0];
        }
      } catch (error) {}

      _n3.default.sort(el, _sort.on || "textContent.trim()", _sort.as, _sort.reverse || false, _sort.order || false);
    });
  }
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.debug;